// 配置全局访问接口地址
// let commonUrl = "//h5test.ag-lotre.com";
let commonUrl = "https://www.xxmmxx.xyz";//源码分享站-ymfxz.com
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl